module.exports = __webpack_public_path__ + "static/level3-33ded45d88037d2e3bd8e0eb1e72e4d1.png";